module.exports = __webpack_public_path__ + "assets/img/1fac6f096574a00826472a6ba1572aaa.png";